import { render } from "./NoticeDetails.vue?vue&type=template&id=fc826794&ts=true"
import script from "./NoticeDetails.vue?vue&type=script&lang=ts"
export * from "./NoticeDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__